module.exports = __webpack_public_path__ + "media/images/rsf-8163ef1227a88652749ba08f17f642e9.png";